<template>
</template>
<script>
import { setIdToken, setAccessToken } from '../utils/auth';

export default {
  name: 'callback',
  mounted() {
    this.$nextTick(() => {
      setAccessToken();
      setIdToken();
      this.$router.push('dashboard');
    });
  },
};
</script>